import React, { useState, useContext } from "react";
import { Disclosure } from "@headlessui/react";
import { ChevronUpIcon } from "@heroicons/react/20/solid";
import Button from "./Button";
import { getCart } from "../utils/localstorage";
import PRODUCTS from "../../src/products.json";
import { CartContext } from "../contexts/CartContext";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const Affiliate = () => {
  const [referral, setReferral] = useState(
    localStorage.getItem("referral") === "true"
  );
  const cartContext = useContext(CartContext);
  const cart = getCart();
  const brochuresProduct = PRODUCTS.find((p) => p.Sku === "B3Bro5");
  const b3BookProduct = PRODUCTS.find((p) => p.Sku === "B3Book5Fr");
  const navigate = useNavigate();

  const onChangeReferral = (e) => {
    setReferral(!referral);
    localStorage.setItem("referral", !referral);
    const isChecked = e.target.checked;
    const productExists = cart.some(
      (item) => item.product.Sku === brochuresProduct.Sku
    );

    if (isChecked && !productExists) {
      cartContext.save([
        ...cart,
        { product: brochuresProduct, qty: 1 },
        { product: b3BookProduct, qty: 1 },
      ]);
      toast(`${brochuresProduct.ProductName} Added!`);
      toast(`${b3BookProduct.ProductName} Added!`);
    } else {
      const updatedCart = cart.filter(
        (item) =>
          item.product.Sku !== brochuresProduct.Sku &&
          item.product.Sku !== b3BookProduct.Sku
      );
      cartContext.save(updatedCart);
      toast(`${brochuresProduct.ProductName} Removed`);
      toast(`${b3BookProduct.ProductName} Removed`);
    }
  };

  return (
    <section className="container mt-4 mx-auto flex-1 p-0 md:p-1 flex flex-col lg:max-w-3xl relative">
      <div className="flex flex-col gap-2">
        <div className="bg-[#302b2b] p-6 rounded-[1rem] w-full">
          <h1 className="pb-4 text-[2.33rem] md:text-4xl roboto-medium">
            <span className="text-white">
              Free B<span className="text-[#00adef] mr-2">3</span>
              Affiliate Program!
            </span>
          </h1>

          {/* Desktop Content */}
          <div className="hidden md:block roboto-regular">
            <p className="py-2  text-[#00adef] text-2xl text-white">
              Start sharing wellness and earning income — it’s simple and free!
            </p>
            <ul className="list-disc pl-4 pb-2">
              <li className="pt-1 text-xl text-white">
                <span className="text-[#00adef]">
                  Your Own Personalized Website
                </span>{" "}
                – Perfect for sharing with friends and family
              </li>
              <li className="pt-1 text-xl text-white">
                <span className="text-[#00adef]">Effortless Sharing</span> –
                Just send your unique link, we handle the rest
              </li>
              <li className="pt-1 text-xl text-white">
                <span className="text-[#00adef]"> Earn Great Commissions </span>{" "}
                – Make at least $80 per Band Set referral!
              </li>
              <li className="pt-1 text-xl text-white">
                        <span className="text-[#00adef]">
                          With the Free Affiliate program
                        </span>{" "}
                        – We will also send you 5 Free Tri-Fold Brochures and 5
                        B3 Booklets to share with your Friends and Family
                      </li>
            </ul>
            <p className="text-[#00adef] mt-4 text-lg text-white">
              Whether you're just getting started or already loving B3, this is
              a great way to share the benefits and get rewarded.
            </p>
          </div>

          {/* Mobile Content - Disclosure */}
          <div className="md:hidden roboto-regular mt-4">
            <Disclosure>
              {({ open }) => (
                <>
                  <Disclosure.Button className="flex w-full justify-between rounded-lg bg-white px-4 py-2 text-left text-lg font-medium text-[#00adef] focus:outline-none">
                    <span>Details</span>
                    <ChevronUpIcon
                      className={`${
                        open ? "rotate-180 transform" : ""
                      } h-5 w-5 text-[#00adef]`}
                    />
                  </Disclosure.Button>
                  <Disclosure.Panel className="pt-4 pb-2 text-white text-md">
                    <p className="text-white pb-2">
                      Start sharing wellness and earning income — it’s simple
                      and free!
                    </p>
                    <ul className="list-disc pl-4 pb-2">
                      <li className="py-1">
                        <span className="text-[#00adef]">
                          Your Own Personalized Website{" "}
                        </span>{" "}
                        – Perfect for sharing with friends and family
                      </li>
                      <li className="py-1">
                        <span className="text-[#00adef]">
                          Effortless Sharing{" "}
                        </span>{" "}
                        – Just send your unique link, we handle the rest
                      </li>
                      <li className="py-1">
                        <span className="text-[#00adef]">
                          {" "}
                          Earn Great Commissions{" "}
                        </span>{" "}
                        – Make at least $80 per Band Set referral!
                      </li>
                      <li className="py-1">
                        <span className="text-[#00adef]">
                          With the Free Affiliate program
                        </span>{" "}
                        – We will also send you 5 Free Tri-Fold Brochures and 5
                        B3 Booklets to share with your Friends and Family
                      </li>
                    </ul>
                    <p className="text-white mt-4">
                      Whether you're just getting started or already loving B3,
                      this is a great way to share the benefits and get
                      rewarded.
                    </p>
                  </Disclosure.Panel>
                </>
              )}
            </Disclosure>
          </div>

          {/* Subscription Opt-out */}
          <div className="flex flex-row items-start mt-8 md:mt-4">
            <label class="relative inline-flex items-center cursor-pointer">
              <input
                type="checkbox"
                value=""
                class="sr-only peer"
                checked={referral}
                onChange={onChangeReferral}
              />
              <div class="w-11 border !border-[#00adef] h-6 mr-4 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
            </label>
            <label class="text-md leading-6 text-white" id="switch-1-label">
              Yes, set me up with my Free Affiliate site for Sharing
            </label>
          </div>
        </div>

        <div className="text-center pt-4">
          <Button
            onClick={() => navigate("/confirmation")}
            className="mx-auto !w-full text-base md:text-lg px-5 py-2 rounded-full font-light mt-2 lg:max-w-[300px]"
          >
            {!referral ? "No Thanks - Continue" : "Yes - Continue"}
          </Button>
        </div>
      </div>
    </section>
  );
};

export default Affiliate;
